/* @ngInject */
export default function DateTimeRangePickerService() {
  const service = this;
  const day = 23;
  const hour = 59;
  const sec = 999;
  const week = 7;
  const month = 30;

  service.setToday = setToday;
  service.setYesterday = setYesterday;
  service.setLastSevenDays = setLastSevenDays;
  service.setLastThirtyDays = setLastThirtyDays;
  service.setPreviousMonth = setPreviousMonth;
  service.datesSetManually = datesSetManually;
  service.isValidDateRange = isValidDateRange;

  function setToday() {
    const dateRange = new DateTimeRange('today');
    return setExtremeTimes(dateRange);
  }

  function setYesterday() {
    const dateRange = new DateTimeRange('yesterday');
    const yesterday = new Date().getDate() - 1;
    dateRange.start.setDate(yesterday);
    dateRange.end.setDate(yesterday);
    return setExtremeTimes(dateRange);
  }

  function setLastSevenDays() {
    const dateRange = new DateTimeRange('lastSeven');
    dateRange.start.setDate(dateRange.start.getDate() - week);
    return setExtremeTimes(dateRange);
  }

  function setLastThirtyDays() {
    const dateRange = new DateTimeRange('lastThirty');
    dateRange.start.setDate(dateRange.start.getDate() - month);
    return setExtremeTimes(dateRange);
  }

  function setPreviousMonth() {
    const dateRange = new DateTimeRange('previousMonth');
    const { start, end } = dateRange;
    start.setDate(1);
    start.setMonth(start.getMonth() - 1); // previous month
    end.setDate(1); // first day of the current month
    end.setHours(0, 0, 0, -1); // -1 ms to roll back to last day of previous month
    return setExtremeTimes(dateRange);
  }

  function datesSetManually() {
    const activeSelection = '';
    return { activeSelection };
  }

  function isValidDateRange(dateRange) {
    const { start, end } = dateRange;
    return start <= end;
  }

  /**
   * @typedef {object} DateTimeRange
   * @property {Date} start
   * @property {Date} end
   */

  /**
   * Sets start day to beginning of the day and the end day to the end of the day
   *
   * @param {DateTimeRange} dateRange The range to set
   * @returns {DateTimeRange} The modified range
   */
  function setExtremeTimes(dateRange) {
    dateRange.start.setHours(0, 0, 0, 0);
    dateRange.end.setHours(day, hour, hour, sec);
    return dateRange;
  }

  function DateTimeRange(activeSelection = '') {
    this.start = new Date();
    this.end = new Date();
    this.activeSelection = activeSelection;
  }

}
